// extracted by mini-css-extract-plugin
module.exports = {"Settings":"Settings_Settings__36XVk","SettingField":"Settings_SettingField__3q1BQ","UpdateAssets":"Settings_UpdateAssets__2ZlYm"};